exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .new-parts-list .new-part {\n  margin-bottom: 30px;\n  font-size: 12px;\n}\n\n.pc .new-parts-list .new-part .price-display {\n  line-height: 1.1;\n  font-size: 14px;\n}\n\n.pc .new-parts-list .new-part .price-display .price {\n  font-family: \"JDSansPro-Medium\", \"Helvetica Neue\", \"Roboto\", helvetica, arial, sans-serif;\n  font-size: 17px;\n  font-weight: bold;\n}\n\n.pc .new-parts-list .new-part .price-display .code {\n  font-family: \"JDSansPro-Medium\", \"Helvetica Neue\", \"Roboto\", helvetica, arial, sans-serif;\n  font-size: 12px;\n}\n\n", ""]);

// exports
